var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[(_vm.showText)?_c('span',{staticClass:"spinner-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('v-progress-circular',{staticStyle:{"width":"100%"},attrs:{"indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }